// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"style_wrap_7842a49af3c20f97125a2a3c4f6d5358"};